<template>
  <div class="item">
    <div class="content">
      <div class="logo">
        <img src="@/assets/avr.png" alt="" style="width: 100%; height: 100%" />
      </div>
      <div class="input_item">
        <div class="input_item_input">
          <input type="text" v-model="inputValue" placeholder="请输入卡号咨询" autofocus />
          <img src="@/assets/1scan.png" alt="" style="
             float: right;
             width: 20px;
             height: 20px;
             line-height: 45px;
             margin: 12.5px;
           " />
        </div>
      </div>
      <div class="input_btn">
        <div class="button" @click="handleClick">立即咨询该卡号</div>
      </div>
      <br>
      <br>
      <!-- <div class="input_btn1">
        <div class="button"  type="info" @click="toActive">去充值激活</div>
      </div> -->
      <div class="input_logo">
        <img src="@/assets/270.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      inputValue: "",
      kfurl1: "http://zhuxiao1.410wl.cn/chat.html",
      kfurl2: "http://xtkf15.iot189.com/chat.html",
    };
  },
  mounted() {
    this.inputValue = localStorage.getItem("recordLoginText");

  },
  methods: {
    toActive(){
      this.$router.push({ path: "/newUser/simLogin" }) //noCode 新增卡板时
    },
    handleClick() {
      if (this.inputValue === "") {
        alert("请输入卡号，无卡号无法分配对应客服");
        return;
      }
      localStorage.setItem("recordLoginText", this.inputValue);
      wxRequest("userProblem/login/kefu", {"iccid":this.inputValue}, "post").then((res) => {
        if (res.data.code === "200") {
          if (res.data.data.supplierCode == '1916675394354802688') {
            window.location.href = 'http://yanzheng.szxxtx.com/?iccid='+this.inputValue;
          } else {
            window.location.href = "https://work.weixin.qq.com/kfid/kfc936d6fd76f9e8553?enc_scene=ENCGh9rMoMTyL4LpCZxr4rRS9cEQASjTFHye1UzncGz72YL"+res.data.data.param;
          }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      })
    },

  },
};
</script>

<style scoped>
.item {
  background: #f5f5f5 url('~@/assets/270.png') no-repeat center;
  background-size: 100% auto;
  background-position: top;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
}

.item .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 123px;
}

.item .content .logo {
  height: 102px;
  width: 102px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
}

.item .content .input_item {
  position: relative;
  margin-top: 25px;
  min-height: 45px;
  width: 339px;
}

.item .content .input_item .input_item_input {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 45px;
  width: 339px;
  background-color: #fdfdfd;
  border-radius: 22px;
  border: 1px solid #b3b3b3;
  z-index: 5;
}

.item .content .input_item .input_item_input input {
  position: absolute;
  border: 0px;
  left: 17px;
  top: 0px;
  line-height: 45px;
  height: 45px;
  width: 240px;
  font-size: 15px;
  z-index: 6;
  letter-spacing: 1px;
  font-weight: 500;
  background-color: transparent;
}

.item .content .input_item .input_item_input input:focus {
  outline: none;
}

.item .content .input_btn {
  position: relative;
  margin-top: 37px;
}

.item .content .input_btn .button {
  width: 339px;
  display: block;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 1px;
  text-align: center;
  background: #333;
  color: #fcfcf2;
  border-radius: 7px;
  cursor: pointer;
  line-height: 45px;
}

.item .content .input_btn1 .button {
  width: 339px;
  display: block;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 1px;
  text-align: center;
  background: #0088d6;
  color: #fcfcf2;
  border-radius: 7px;
  cursor: pointer;
  line-height: 45px;
}

.item .content .input_logo {
  position: fixed;
  top: calc(100vh - 48px);
  margin: auto;
  text-align: center;
}

.item .content .input_logo img {
  width: 100px;
  height: 23px;
}
</style>